import { ClearUser } from "../../Redux/UserSlice/userSlice";
import { sendPostCallToSever } from "../Axios/Axios";
import { auth } from "../../Config/firebase-config";
import { ClearAuth, setAuthToken } from "../../Redux/AuthSlice/authSlice";
import { ClearImage } from "../../Redux/MainImage/imageSlice";
import { deleteAll } from "../../Redux/WaterMarks/watermarks";
import { signOut } from "firebase/auth";
import type { AppDispatch } from "../../Redux/store";

const LoginAPI = () => (dispatch: AppDispatch) => {
  return sendPostCallToSever({}, "users/login").then(async (result) => {
    const data = result.data;
    // dispatch(setUserVerify(data))
    if (data) {
      const authToken = await RefreshToken();
      dispatch(setAuthToken(authToken));

      return data;
    } else return false;
  });
};

const RefreshToken = (): Promise<string | undefined> => {
  const user = auth.currentUser;
  if (!user) return Promise.resolve(undefined);
  return user
    .getIdTokenResult(true)
    .then((idTokenResult) => {
      const refreshedToken = idTokenResult.token;
      return refreshedToken;
    })
    .catch((error) => {
      console.log("refreshed error", error);
      return undefined;
    });
};

const Logout = () => (dispatch: AppDispatch) => {
  signOut(auth);
  dispatch(ClearImage());
  dispatch(deleteAll());
  dispatch(ClearUser());
  dispatch(ClearAuth());
};

export { LoginAPI, RefreshToken, Logout };
